
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.886 11.238c.161.298.151.65-.03.938a.975.975 0 01-.693.441v4.327c0 .582-.49 1.056-1.092 1.056H6.938c-.602 0-1.091-.474-1.091-1.056V12.62a.98.98 0 01-.7-.437.925.925 0 01-.04-.93l1.078-2.087a.986.986 0 01.883-.528h9.813c.369 0 .704.196.874.511l1.131 2.09zm-2.074 5.053v-3.253a.409.409 0 00-.416-.402H7.614c-.23 0-.415.18-.415.402v3.253c0 .222.186.402.415.402h8.782c.23 0 .416-.18.416-.402zm-9.69-8.984a.665.665 0 01-.676-.653c0-.361.303-.654.676-.654h9.766c.374 0 .677.293.677.654 0 .36-.303.653-.677.653H7.122z"}})])
          )
        }
      }
    